import type { AddressClient } from '@/api/modules/addresses/addresses.types'

/**
 * Формирование полной строки адреса
 * @param address - поля адреса
 */
export const formatToFullVisibleAddress = (address: AddressClient): string => {
  const { street, locality, house, apartment, flat } = address

  let result = ''

  // Приводим к нижнему регистру
  const loverLocality = locality ? locality.toLocaleLowerCase() : null

  // Если locality существует и не равен улице
  if (Boolean(loverLocality) && loverLocality !== street.toLocaleLowerCase())
    result = `${locality}`

  // Если locality есть
  if (result) result += `, `

  const streetFirstSymbolUpper = street

  // Улица с домом всегда будет, конкатенируем значения
  result += `${streetFirstSymbolUpper} д. ${house}`

  // На /v3/ - apartment на /v4/ - flat
  const newFlat = apartment || flat

  if (newFlat) result = `${result}, кв ${newFlat}`

  return result
}
